<main class="ptf-shell">
    <ng-container *ngIf="view.View === null">
        <div class="ptf-shell__splash">
            <img src="logo-dark.png" alt="Pinpad">
        </div>
    </ng-container>

    <ng-container *ngIf="view.View !== null">
        <upp-login *ngIf="view.View === 'LOGIN'"></upp-login>

        <div class="ptf-shell__app" *ngIf="view.View !== 'LOGIN'">
            <upp-topbar></upp-topbar>
            <upp-user-edit></upp-user-edit>

            <ng-container *ngIf="view.View === 'USER'">
                <upp-user-start></upp-user-start>
            </ng-container>

            <ng-container *ngIf="view.View === 'PLACE'">
                <app-ptf-place-shell></app-ptf-place-shell>
            </ng-container>
        </div>
    </ng-container>

    <router-outlet></router-outlet>
</main>
